export const fallbackLng = 'fr'
export const languages = [fallbackLng, 'en']
export const defaultNS = ['translation', "cgu"]
export const cookieName = 'i18next'

export function getOptions (lng = fallbackLng, ns = defaultNS) {
  return {
    ns,
    lng,
    defaultNS,
    fallbackLng,
    debug: false,
    fallbackNS: defaultNS,
    supportedLngs: languages,
    react: { useSuspense : true },
    interpolation: { escapeValue: false },
  }
}